module.exports = {
      id: "comm-entertainment-usage",
      viewBox: "0 0 269.757 51.703",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-entertainment",
      toString: function () {
        return this.url;
      }
    }